export const checkIformulaIsValid = formula => {
  const regex = /%([^%]+)%/g
  let match
  const parametros = []

  while ((match = regex.exec(formula)) !== null) {
    parametros.push(match[0])
  }

  // Reemplazar los parámetros encontrados con "1"
  let formulaClean = formula
  parametros.forEach(param => {
    formulaClean = formulaClean.replace(param, '1')
  })

  // Si quedan '%' sin emparejar, es inválido
  if (formulaClean.includes('%')) {
    return false
  }

  // Si hay letras fuera de %...%, es inválido
  if (/[a-zA-Z]/.test(formulaClean)) {
    return false
  }

  // Validar que la expresión matemática resultante sea válida
  try {
    new Function(`return (${formulaClean})`)
  } catch {
    return false
  }

  return true
}
